import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';

import { DropdownDirective } from 'shared/dropdown/dropdown.directive';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'change-status-dropdown',
  templateUrl: 'change-status-dropdown.component.html',
  styleUrls: ['change-status-dropdown.component.scss'],
})
export class ChangeStatusDropdownComponent {
  @Input() dropup: boolean = true;
  @Input() icon: string = 'change-status-icon';
  @Input() title: string = 'Change status';
  @Input() actionsList: Array<any>;

  @Output() actionSelected = new EventEmitter();

  @ViewChild(DropdownDirective, {static: false})
  dropdownWrap: DropdownDirective | void;

  onSelectedChange($event: any) {
    this.actionSelected.emit($event);
  }
}
